import { css, etiColors } from '@eti/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const wrapperStyles = length => css`
  background-color: rgb(255 255 255 / 50%);
  border-radius: 10px;
  height: 20px;
  left: 40px;
  margin-bottom: 2.2em;
  position: absolute;
  width: calc(100px * ${length} + 20px);

  [dir='rtl'] & {
    left: unset;
    right: 40px;
  }
`;
const dotStyles = (position, done) => css`
  background-color: ${etiColors.white};
  border-radius: 50%;
  height: 8px;
  left: calc(100px * ${position} + 10px);
  opacity: ${done ? 0 : 1};
  position: absolute;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  transition:
    left 0.5s cubic-bezier(0.26, 0.01, 0.28, 1.14),
    opacity 0.5s;
  width: 8px;

  [dir='rtl'] & {
    left: unset;
    right: calc(100px * ${position} + 2px);
    transition: right 0.5s cubic-bezier(0.26, 0.01, 0.28, 1.14);
  }
`;
const progressLineStyles = progress => css`
  background-color: #10a700;
  border-radius: 10px;
  height: 100%;
  transition: width 0.5s;
  width: calc(100px * ${progress} + 20px);
`;
const StepIndicatorProgress = _ref => {
  let {
    length,
    progress,
    isDone,
    shouldHidePointIndicator
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: wrapperStyles(length),
    "data-testid": "seatMap-stepIndicator-progressBar",
    children: [/*#__PURE__*/_jsx("div", {
      className: dotStyles(progress, isDone || shouldHidePointIndicator)
    }), /*#__PURE__*/_jsx("div", {
      className: progressLineStyles(isDone ? length : progress)
    })]
  });
};
export default StepIndicatorProgress;
//# sourceMappingURL=ProgressBar.js.map